import { todayIso } from '@apka/core'
import { useState } from 'react'
import { IkonaStrzalkaLewo, IkonaStrzalkaPrawo } from './Ikony.js'
import { nazwaMiesiaca, przesunMiesiac } from './format.js'
import './wybor-miesiaca.css'

export interface Miesiac {
  rok: number
  miesiac: number
}

export function biezacyMiesiac(): Miesiac {
  const dzis = todayIso()
  return { rok: Number(dzis.slice(0, 4)), miesiac: Number(dzis.slice(5, 7)) }
}

export interface SterowanieMiesiacem {
  miesiac: Miesiac
  przesun(o: number): void
  doDzis(): void
  ustaw(nowy: Miesiac): void
  /** −1 gdy cofnięto, 1 gdy przesunięto w przód. Steruje stroną wejścia treści. */
  kierunek: number
  /** Rośnie przy każdej zmianie — pozwala odtworzyć animację tym samym kierunkiem. */
  odslona: number
}

export function useMiesiac(): SterowanieMiesiacem {
  const [wartosc, ustaw] = useState<Miesiac>(biezacyMiesiac)
  const [kierunek, ustawKierunek] = useState(0)
  const [odslona, ustawOdslone] = useState(0)

  const zapisz = (nowy: Miesiac, skad: number) => {
    ustawKierunek(skad)
    ustawOdslone((poprzednia) => poprzednia + 1)
    ustaw(nowy)
  }

  return {
    miesiac: wartosc,
    przesun: (o: number) =>
      zapisz(przesunMiesiac(wartosc.rok, wartosc.miesiac, o), Math.sign(o)),
    doDzis: () => {
      const teraz = biezacyMiesiac()
      const roznica = teraz.rok * 12 + teraz.miesiac - (wartosc.rok * 12 + wartosc.miesiac)
      zapisz(teraz, Math.sign(roznica))
    },
    ustaw: (nowy: Miesiac) => {
      const roznica = nowy.rok * 12 + nowy.miesiac - (wartosc.rok * 12 + wartosc.miesiac)
      zapisz(nowy, Math.sign(roznica))
    },
    kierunek,
    odslona,
  }
}

interface Props {
  miesiac: Miesiac
  onPrzesun(o: number): void
  onDzis(): void
  /** W widoku rocznym strzałki przeskakują lata, więc nazwa miesiąca zbędna. */
  tylkoRok?: boolean
}

export function WyborMiesiaca({ miesiac, onPrzesun, onDzis, tylkoRok = false }: Props) {
  const teraz = biezacyMiesiac()
  const toDzis = tylkoRok
    ? teraz.rok === miesiac.rok
    : teraz.rok === miesiac.rok && teraz.miesiac === miesiac.miesiac

  return (
    <div className="wybor-miesiaca">
      <button
        type="button"
        className="wybor-miesiaca__strzalka"
        onClick={() => onPrzesun(-1)}
        aria-label={tylkoRok ? 'Poprzedni rok' : 'Poprzedni miesiąc'}
      >
        <IkonaStrzalkaLewo width={18} height={18} />
      </button>

      <p className="wybor-miesiaca__etykieta" aria-live="polite">
        {tylkoRok ? null : `${nazwaMiesiaca(miesiac.miesiac)} `}
        <span>{miesiac.rok}</span>
      </p>

      <button
        type="button"
        className="wybor-miesiaca__strzalka"
        onClick={() => onPrzesun(1)}
        aria-label={tylkoRok ? 'Następny rok' : 'Następny miesiąc'}
      >
        <IkonaStrzalkaPrawo width={18} height={18} />
      </button>

      {toDzis ? null : (
        <button type="button" className="wybor-miesiaca__dzis" onClick={onDzis}>
          {tylkoRok ? 'Ten rok' : 'Dziś'}
        </button>
      )}
    </div>
  )
}
